import StoxxoBanner from './StoxxoBanner';
import StoxxoSection from './StoxxoSection';

function Stoxxo() {
  return (
    <div>
      <StoxxoBanner />
      <StoxxoSection />
    </div>
  );
}

export default Stoxxo;